import React from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import useTheme from '@mui/material/styles/useTheme';
import { FormControl, Select, MenuItem } from '@mui/material';
import { Box } from '@mui/material';


export const UnitsSelector = observer(({ mState, sx }) => {
    const theme = useTheme();

    const onChange = (event) => {
        let unitsId = event.target.value;
        if (unitsId === 'default') {
            unitsId = null;
        }
        mState.setInputUnits(unitsId);
    }

    return (
        <>
            {(!mState.value_is_computed && mState.unitsAvailable.length)
                ?
                <FormControl variant="standard" sx={{
                    fontSize: "12px",
                    m: 0,
                    p: 0,
                    ...sx,
                }}>
                    <Select
                        value={mState.value?.alternativeUnits || 'default'}
                        onChange={onChange}
                        label="units"
                        sx={{
                            fontSize: "13px",
                            m: 0,
                            p: 0,
                            "& .MuiSelect-select": {p:0}, // make it smaller
                            color: theme.palette.text.secondary,
                        }}
                    >
                        {/* Default */}
                        <MenuItem key="default" value="default">{mState.defaultUnits}</MenuItem>
                        {/* Alternative */}
                        {mState.unitsAvailable.map((unit) => (
                            <MenuItem key={unit.id} value={unit.id}>{unit.units}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                :
                <Box sx={{
                    fontSize: "13px",
                    color: theme.palette.text.secondary,
                    textAlign: "right",
                    mr: 1,
                }}>{mState.defaultUnits}</Box>
            }
        </>
    );
});


